<template>
  <div class="d-flex align-center">
    <template v-for="item in headerNavigation" :key="item.id">
      <!-- Dropdown menu for items with children -->
      <v-menu
        v-if="item.children && item.children.length > 0"
        offset-y
        transition="slide-y-transition"
      >
        <template v-slot:activator="{ props }">
          <v-btn
            v-bind="props"
            variant="text"
            class="mx-1"
          >
            <v-icon v-if="convertIcon(item.icon)" start>{{ convertIcon(item.icon) }}</v-icon>
            {{ item.title }}
            <v-icon end>mdi-menu-down</v-icon>
          </v-btn>
        </template>
        
        <v-list>
          <v-list-item
            v-for="child in item.children"
            :key="child.id"
            :to="child.route"
            :active="isActiveRoute(child.route)"
          >
            <v-list-item-title>{{ child.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      
      <!-- Regular navigation items -->
      <v-btn
        v-else
        :to="item.route"
        variant="text"
        class="mx-1"
        :active="isActiveRoute(item.route)"
      >
        <v-icon v-if="convertIcon(item.icon)" start>{{ convertIcon(item.icon) }}</v-icon>
        {{ item.title }}
      </v-btn>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'HeaderMenu',
  computed: {
    ...mapGetters('navigation', ['headerNavigation']),
    currentRoute() {
      return this.$route.path;
    }
  },
  methods: {
    isActiveRoute(route) {
      return this.currentRoute === route;
    },
    
    convertIcon(bootstrapIcon) {
      // Map Bootstrap icons to Material Design Icons
      const iconMap = {
        'bi bi-gear': 'mdi-cog',
        'bi bi-person': 'mdi-account',
        'bi bi-box-arrow-right': 'mdi-logout',
        'bi bi-box-arrow-in-right': 'mdi-login',
        'bi bi-person-plus': 'mdi-account-plus',
      };
      
      return iconMap[bootstrapIcon] || null;
    }
  }
};
</script>

<style scoped>
/* Custom styles for header menu */
.v-btn {
  text-transform: none;
  font-weight: 400;
}

.v-btn--active {
  font-weight: 600;
}
</style>